<template>
  <div class="base_main helmet_main bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('DataRecord') }} > {{ $t('SystemStatistics') }}</div>
    <div class="common-table-cnt common-aside-cnt-top">
      <div class="common-aside">
        <div class="serachLine">
          <el-input :placeholder="$t('organizationName')" v-model="filterText" clearable> </el-input>
          <el-button type="primary" class="serachBtn"> {{ $t('searchM') }} </el-button>
        </div>
        <el-tree
          :data="mechanismData"
          :props="defaultProps"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          highlight-current
          :filter-node-method="filterNode"
          ref="dataStaticTree"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span class="node-txt">{{ node.data.name }}</span>
          </span>
        </el-tree>
      </div>
      <div class="common-aside-main" style="padding-right:15px;overflow:auto;margin-bottom:20px;">
        <div class="main search" style="padding-right:20px;">
          <el-form :inline="true" :model="formInline" class="search demo-form-inline">
            <el-form-item :label="$t('Recordtime')">
              <el-radio-group v-model="timeSelect" @change="selectTimeSlot">
                <el-radio label="oneWeek" value="oneWeek">{{ $t('oneWeek') }}</el-radio>
                <el-radio label="oneMonth" value="oneMonth">{{ $t('oneMonth') }}</el-radio>
                <el-radio label="all" value="all">{{ $t('all') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('IsContainChild')">
              <el-radio-group v-model="formInline.isContainChild">
                <el-radio label='0' value='0'>{{ $t('NoContainChild') }}</el-radio>
                <el-radio label='1' value='1'>{{ $t('ContainChild') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('Recordtime')" class="datetime">
              <el-date-picker
                v-model="formInline.logDateBegin"
                :placeholder="$t('startDate')"
                type="date"
                value-format="yyyy-MM-dd"
                :clearable="true"
                popper-class="date-picker-blue-hw"
                @change="pickBegin"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('TO')" class="datetime">
              <el-date-picker
                v-model="formInline.logDateEnd"
                :placeholder="$t('endDate')"
                type="date"
                value-format="yyyy-MM-dd"
                :clearable="true"
                popper-class="date-picker-blue-hw"
                @change="pickEnd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="serachBtn" @click="_getStatistics(true)">{{ $t('query') }}</el-button>
              <el-button type="primary" class="serachBtn" @click="_exportStatistics()">{{ $t('exportButton') }}</el-button>
            </el-form-item>
          </el-form>
          <div class="view-info common-blue-tabs">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane :label="$t('mechanismQuery')" name="mechanism"></el-tab-pane>
              <el-tab-pane :label="$t('userQuery')" name="userList"></el-tab-pane>
            </el-tabs>
          </div>
          <div class="statis-chart">
            <div class="user-activity">
              <!-- 机构使用比例 -->
              <div id="useProportion" class="statis-echart" :style="{ width: '100%', height: '100%' }"></div>
              <div class="pagination" v-if="activeName === 'userList'">
                <span>{{ staticProportCurrentPage }}/{{ staticProport.totalData }}</span>
                <el-pagination
                  layout="prev, next"
                  @current-change="handleproportion"
                  :current-page="staticProport.currentPage"
                  :page-size="staticProport.pageSize"
                  :total="staticProport.totalUser"
                >
                </el-pagination>
              </div>
            </div>
            <div class="user-activity">
              <div id="institutActivity" class="statis-echart" :style="{ width: '100%', height: '100%' }"></div>
              <div class="pagination">
                <span>{{ userTimeLineCurrentPage }}/{{ userTimeLine.totalData }}</span>
                <el-pagination
                  layout="prev, next"
                  @current-change="handleCurrentChange"
                  :current-page="userTimeLine.currentPage"
                  :page-size="userTimeLine.pageSize"
                  :total="userTimeLine.totalUser"
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <div class="statis-chart">
            <div class="user-activity">
              <div id="mediaStatistics" class="statis-echart" :style="{ width: '100%', height: '100%' }"></div>
              <div class="pagination">
                <span>{{ mediaTimeLineCurrentPage }}/{{ mediaTimeLine.totalData }}</span>
                <el-pagination
                  layout="prev,next"
                  @current-change="handleMediaChange"
                  :current-page="mediaTimeLine.currentPage"
                  :page-size="mediaTimeLine.pageSize"
                  :total="mediaTimeLine.totalUser"
                >
                </el-pagination>
              </div>
            </div>
            <div class="user-activity">
              <div id="totalDuration" class="statis-echart" :style="{ width: '100%', height: '100%' }"></div>
              <div class="pagination">
                <span>{{ duratTimeLineCurrentPage }}/{{ duratTimeLine.totalData }}</span>
                <el-pagination
                  layout="prev,next"
                  @current-change="handleDuratChange"
                  :current-page="duratTimeLine.currentPage"
                  :page-size="duratTimeLine.pageSize"
                  :total="duratTimeLine.totalUser"
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <div class="statis-chart">
            <div class="user-activity">
              <div id="trajectory" class="statis-echart" :style="{ width: '100%', height: '100%' }"></div>
              <div class="pagination">
                <span>{{ traceTimeLineCurrentPage }}/{{ traceTimeLine.totalData }}</span>
                <el-pagination
                  layout="prev,next"
                  @current-change="handleTraceChange"
                  :current-page="traceTimeLine.currentPage"
                  :page-size="traceTimeLine.pageSize"
                  :total="traceTimeLine.totalUser"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOus } from '@/api/UserList'
import { datetimeFullZero } from '@/api/common'
import { getStatistics, exportStatistics, allFullNames, ouMapIncludeChildren, getStatisTrace } from '@/api/log'
import { splitArray, sortData, downloadBlobExcel } from '@/util/common'
export default {
  data() {
    return {
      formInline: {
        logDateBegin: '',
        logDateEnd: '',
        isContainChild: '1',
      },
      // 记录数据选择，oneWeek：周，oneMonth：月，all：全部
      timeSelect: 'oneWeek',
      // 结构树搜索
      filterText: '',
      mechanismData: [],
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      ids: '',
      titleText: '',
      legendData: [],
      seriesData: '',
      colors: [],
      // 当前机构数据
      currentItem: {},
      statisticsData: [],
      // 使用比例/ 用户活跃度比例 数据
      proport: { UseProportion: [], Xproport: [] },
      // 某个机构下 所有用户数据
      userNames: [],
      // 某个机构下 所有子机构数据
      mapIncludeChild: [],
      // 活跃度统计图 X轴数据
      mapXAxisData: [],
      // 媒体统计图 音频数据
      mediaAudioData: [],
      // 媒体统计图 视频数据
      mediaMovieData: [],
      // 媒体统计图 照片数据
      mediaPhotoData: [],
      // 媒体统计图 X轴数据
      mediaXdata: [],
      // 视频总时长数据
      timeData: [],
      // 当前tab mechanism： 机构，userList：用户
      activeName: 'mechanism',
      // 饼图切换结构与用户的 title
      pieTitle: { parTitle: this.$t('mechanismRate'), seriesName: this.$t('deviceNum') },
      echartTitle: this.$t('mechanism'),
      echarts: {
        // echart 图公用颜色
        textColor: '',
        Yline: '',
        activeColor: [],
        mediaColor: [],
        userColor: [],
      },
      videoDuration: [], // 机构视频总时长统计图 X轴数据
      getTimeE: '',
      // 轨迹统计数据
      traceData: { traceXAxis: [], traceLineData: [] },
      // 机构活跃度分页数据
      userTimeLineCurrentPage: 1,
      userTimeLine: { totalUser: 0, XuserData: [], userOnline: [], currentPage: 1, totalData: 0, pageSize: 11 },
      // echart X轴数据重新定义
      userEchart: { userxAxis: [], mediaxAxis: [], duratxAxis: [], GJxAxis: [] },
      // 机构媒体分页数据
      mediaTimeLineCurrentPage: 1,
      mediaTimeLine: {
        totalUser: 0,
        XuserData: [],
        mediaAudio: [],
        mediaMovie: [],
        mediaPhoto: [],
        currentPage: 1,
        totalData: 0,
        pageSize: 11,
      },
      // 机构视频总时长分页数据
      duratTimeLineCurrentPage: 1,
      duratTimeLine: { totalUser: 0, XuserData: [], duratOnline: [], currentPage: 1, totalData: 0, pageSize: 11 },
      // 轨迹统计分页数据
      traceTimeLineCurrentPage: 1,
      traceTimeLine: { totalUser: 0, XuserData: [], traceOnline: [], currentPage: 1, totalData: 0, pageSize: 11 },
      staticProportCurrentPage: 1,
      staticProport: { totalUser: 0, XuserData: [], proportOnline: [], currentPage: 1, totalData: 0, pageSize: 11 },
    }
  },
  components: {},
  methods: {
    pickBegin(value) {
      this.timeSelect = ''
      this.formInline.logDateBegin = value !== null ? datetimeFullZero(value) : ''
    },
    pickEnd(value) {
      this.timeSelect = ''
      this.formInline.logDateEnd = value
      let newdate = new Date(value)
      let pickDateEnd = newdate.getTime() + 3600 * 1000 * 24 * 1
      this.getTimeE = value !== null ? datetimeFullZero(pickDateEnd) : ''
    },
    // 节点过滤
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 点击机构/用户查看
    handleClick() {
      if (this.activeName === 'mechanism') {
        this.echartTitle = this.$t('mechanism')
        // this.echarts.userColor = ['rgb(104,207,239)', 'rgb(42,125,135)']
        this.echarts.userColor = ['#2096FF', '#3CFFC4']
      } else {
        this.echartTitle = this.$t('user')
      }
      this.proport = { UseProportion: [], Xproport: [] }
      this.selectTimeSlot()
      // 机构活跃度分页数据
      this.userTimeLineCurrentPage = 1
      this.mediaTimeLineCurrentPage = 1
      this.duratTimeLineCurrentPage = 1
      this.traceTimeLineCurrentPage = 1
      this.staticProportCurrentPage = 1
      this.userTimeLine = {
        totalUser: 0,
        currentPage: 1,
        totalData: 0,
        pageSize: 11,
      }
      // 机构媒体分页数据
      this.mediaTimeLine = {
        totalUser: 0,
        currentPage: 1,
        totalData: 0,
        pageSize: 11,
      }
      // 机构视频总时长分页数据
      this.duratTimeLine = {
        totalUser: 0,
        currentPage: 1,
        totalData: 0,
        pageSize: 11,
      }
      // 轨迹统计分页数据
      this.traceTimeLine = {
        totalUser: 0,
        currentPage: 1,
        totalData: 0,
        pageSize: 11,
      }
      this.$forceUpdate()
    },
    // 点击选择 周 /月 / 全部
    selectTimeSlot() {
      let date = new Date()
      if (!this.getTimeE) {
        let dateEnd = date.getTime() + 3600 * 1000 * 24 * 1
        // 传值给 方法获取日期的最后时分秒
        this.getTimeE = datetimeFullZero(dateEnd)
      }
      var newTimeB = null
      if (this.timeSelect === 'oneWeek') {
        newTimeB = date.getTime() - 3600 * 1000 * 24 * 6
        // 传值给 方法获取日期的最开始时分秒
        let getTimeb = datetimeFullZero(newTimeB)
        this.formInline.logDateBegin = getTimeb
        this.formInline.logDateEnd = date
      } else if (this.timeSelect === 'oneMonth') {
        newTimeB = date.getTime() - 3600 * 1000 * 24 * 30
        let getTimeb = datetimeFullZero(newTimeB)
        this.formInline.logDateBegin = getTimeb
        this.formInline.logDateEnd = date
      } else if (this.timeSelect === 'all') {
        this.formInline.logDateBegin = ''
        this.formInline.logDateEnd = ''
        this.getTimeE = ''
      }
      this.userEchart = { userxAxis: [], mediaxAxis: [], duratxAxis: [], GJxAxis: [] }
      this._getStatistics(true)
    },
    getChartColor(val) {
      let color = val === undefined ? localStorage.getItem('theme') : val
      this.echarts.userColor = ['#2096FF', '#3CFFC4']
      if (color === 'dark') {
        // 深色时的线条颜色
        this.echarts.textColor = '#fff'
        this.echarts.activeColor[0] = 'rgb(32, 150, 255)'
        this.echarts.Yline = 'rgba(229, 229, 229, 0.1)'
      } else {
        // 浅色时的线条颜色
        this.echarts.textColor = '#404042'
        this.echarts.activeColor[0] = 'rgb(42,125,135)'
        this.echarts.Yline = 'rgba(232, 236, 243, 1)'
      }
      this.getUseProportion()
      this.getHistogram()
      this.getTrajectory()
      this.getmediaStatistics()
      this.getTotalDuration()
    },
    // 机构使用比例/ 用户活跃度
    getUseProportion() {
      this.$nextTick(() => {
        var myChart = this.$echarts.init(document.getElementById('useProportion'))
        myChart.clear()
        myChart.setOption({})
        if (this.activeName === 'mechanism') {
          myChart.setOption({
            title: {
              // 标题
              text: this.pieTitle.parTitle,
              left: 'left',
              textStyle: {
                color: this.echarts.textColor,
              },
            },
            tooltip: {
              // 鼠标悬浮是的提示
              trigger: 'item',
            },
            legend: {
              top: '8%',
              left: 'center',
              textStyle: {
                color: this.echarts.textColor,
              },
            },
            color: this.echarts.userColor,
            grid: {
              top: 50,
              left: 27,
              right: 5,
              bottom: 20,
              containLabel: true,
            },
            series: [
              {
                name: this.pieTitle.seriesName,
                type: 'pie',
                radius: '50%',
                data: this.proport.UseProportion,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                  },
                },
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      formatter: '{b} : {c}\n({d}%)', // 自定义显示格式(b:name, c:value, d:百分比)
                    },
                    labelLine: {
                      show: true,
                      length: 0.005,
                    },
                  },
                },
              },
            ],
          })
        } else {
          myChart.setOption({
            title: {
              text: this.pieTitle.parTitle,
              left: 'left',
              textStyle: {
                color: this.echarts.textColor,
              },
            },
            tooltip: {
              trigger: 'item',
              transitionDuration: 0, //加上这个可以防止抖动
            },
            legend: {
              top: '5%',
              data: [this.$t('onlineRate')],
              textStyle: {
                color: this.echarts.textColor,
              },
            },
            xAxis: {
              type: 'category',
              data: this.proport.Xproport,
              axisLabel: {
                //展示角度
                // rotate: 30,
                textStyle: {
                  color: this.echarts.textColor,
                },
              },
              axisLine: {
                lineStyle: {
                  color: this.echarts.Yline, //更改坐标轴颜色
                },
              },
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                textStyle: {
                  color: this.echarts.textColor,
                },
              },
              splitLine: {
                // 自定义网格线样式
                lineStyle: {
                  type: 'solid',
                  color: this.echarts.Yline,
                },
              },
              axisLine: {
                lineStyle: {
                  color: this.echarts.Yline, //更改坐标轴颜色
                },
              },
            },
            grid: {
              top: 60,
              left: 27,
              right: 5,
              bottom: 20,
              containLabel: true,
            },
            series: [
              {
                data: this.proport.UseProportion,
                type: 'bar',
                barWidth: 30, //柱图宽度
                name: this.$t('onlineRate'),
                itemStyle: {
                  normal: {
                    color: function(params) {
                      let colorList = [
                        '#C33531',
                        'rgb(104,207,239)',
                        'rgb(42,125,135)',
                        '#EFE42A',
                        '#64BD3D',
                        '#EE9201',
                        '#29AAE3',
                        '#B74AE5',
                        '#0AAF9F',
                        '#E89589',
                        '#16A085',
                        '#4A235A',
                        '#C39BD3 ',
                        '#F9E79F',
                        '#BA4A00',
                        '#ECF0F1',
                        '#616A6B',
                        '#EAF2F8',
                        '#4A235A',
                        '#3498DB',
                      ]
                      return colorList[params.dataIndex]
                    },
                  },
                },
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  textStyle: {
                    //数值样式
                    // color: 'rgb(42,125,135)',
                    fontSize: 16,
                  },
                },
              },
            ],
          })
        }
      })
    },
    // 机构活跃度统计图
    getHistogram() {
      this.$nextTick(() => {
        var myChart = this.$echarts.init(document.getElementById('institutActivity'))
        myChart.setOption({
          title: {
            text: this.echartTitle + this.$t('activeStatistics'),
            left: 'left',
            textStyle: {
              color: this.echarts.textColor,
            },
          },
          tooltip: {
            trigger: 'item',
            transitionDuration: 0, //加上这个可以防止抖动
          },
          color: this.echarts.activeColor,
          legend: {
            top: '5%',
            data: [this.$t('onlineTime')],
            textStyle: {
              color: this.echarts.textColor,
            },
          },
          xAxis: {
            type: 'category',
            data: this.userEchart.userxAxis,
            axisLabel: {
              //展示角度
              // rotate: 30,
              textStyle: {
                color: this.echarts.textColor,
              },
            },
            axisLine: {
              lineStyle: {
                color: this.echarts.Yline, //更改坐标轴颜色
              },
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: this.echarts.textColor,
              },
            },
            splitLine: {
              // 自定义网格线样式
              lineStyle: {
                type: 'solid',
                color: this.echarts.Yline,
              },
            },
            axisLine: {
              lineStyle: {
                color: this.echarts.Yline, //更改坐标轴颜色
              },
            },
          },
          grid: {
            top: 60,
            left: 27,
            right: 5,
            bottom: 20,
            containLabel: true,
          },
          series: [
            {
              data: this.seriesData,
              type: 'bar',
              barWidth: 30, //柱图宽度
              name: this.$t('onlineTime'),
              itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: 'top', //在上方显示
                    textStyle: {
                      //数值样式
                      color: '#2096FF',
                      fontSize: 16,
                    },
                  },
                },
              },
            },
          ],
        })
      })
    },
    // 机构媒体统计图
    getmediaStatistics() {
      this.$nextTick(() => {
        var myChart = this.$echarts.init(document.getElementById('mediaStatistics'))
        myChart.setOption({
          title: {
            text: this.echartTitle + this.$t('mediaStatistics'),
            left: 'left',
            textStyle: {
              color: this.echarts.textColor,
            },
          },
          tooltip: {
            trigger: 'item',
            transitionDuration: 0, //加上这个可以防止抖动
          },
          legend: {
            top: '5%',
            data: [this.$t('video'), this.$t('voice'), this.$t('photo')],
            textStyle: {
              color: this.echarts.textColor,
            },
          },
          xAxis: {
            type: 'category',
            data: this.userEchart.mediaxAxis,
            axisLabel: {
              //展示角度
              // rotate: 30,
              textStyle: {
                color: this.echarts.textColor,
              },
            },
            axisLine: {
              lineStyle: {
                color: this.echarts.Yline, //更改坐标轴颜色
              },
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: this.echarts.textColor,
              },
            },
            splitLine: {
              // 自定义网格线样式
              lineStyle: {
                type: 'solid',
                color: this.echarts.Yline,
              },
            },
            axisLine: {
              lineStyle: {
                color: this.echarts.Yline, //更改坐标轴颜色
              },
            },
          },
          grid: {
            top: 60,
            left: 27,
            right: 5,
            bottom: 20,
            containLabel: true,
          },
          series: [
            {
              stack: '1',
              data: this.mediaMovieData,
              type: 'bar',
              barWidth: 30, //柱图宽度
              name: this.$t('video'),
              itemStyle: {
                normal: { color: '#2096FF' },
              },
            },
            {
              stack: '1',
              data: this.mediaAudioData,
              type: 'bar',
              barWidth: 30, //柱图宽度
              name: this.$t('voice'),
              itemStyle: {
                normal: { color: '#3CFFC4' },
              },
            },
            {
              stack: '1',
              data: this.mediaPhotoData,
              type: 'bar',
              barWidth: 30, //柱图宽度
              name: this.$t('photo'),
              itemStyle: {
                normal: { color: '#FFD96A' },
              },
            },
          ],
        })
      })
    },
    // 机构视频总时长统计图
    getTotalDuration() {
      this.$nextTick(() => {
        var myChart = this.$echarts.init(document.getElementById('totalDuration'))
        myChart.setOption({
          title: {
            text: this.echartTitle + this.$t('videoAllDuration'),
            left: 'left',
            textStyle: {
              color: this.echarts.textColor,
            },
          },
          tooltip: {
            trigger: 'item',
            transitionDuration: 0, //加上这个可以防止抖动
          },
          color: ['#2096FF'],
          legend: {
            top: '5%',
            data: [this.$t('minutes')],
            textStyle: {
              color: this.echarts.textColor,
            },
          },
          xAxis: {
            type: 'category',
            data: this.userEchart.duratxAxis,
            axisLabel: {
              //展示角度
              // rotate: 30,
              textStyle: {
                color: this.echarts.textColor,
              },
            },
            axisLine: {
              lineStyle: {
                color: this.echarts.Yline, //更改坐标轴颜色
              },
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: this.echarts.textColor,
              },
            },
            splitLine: {
              // 自定义网格线样式
              lineStyle: {
                type: 'solid',
                color: this.echarts.Yline,
              },
            },
            axisLine: {
              lineStyle: {
                color: this.echarts.Yline, //更改坐标轴颜色
              },
            },
          },
          grid: {
            top: 60,
            left: 27,
            right: 5,
            bottom: 20,
            containLabel: true,
          },
          series: [
            {
              data: this.timeData,
              type: 'bar',
              barWidth: 30, //柱图宽度
              name: this.$t('minutes'),
              itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: 'top', //在上方显示
                    textStyle: {
                      //数值样式
                      color: '#2096FF',
                      fontSize: 16,
                    },
                  },
                },
              },
            },
          ],
        })
      })
    },
    // 轨迹统计图
    getTrajectory() {
      this.$nextTick(() => {
        var myChart = this.$echarts.init(document.getElementById('trajectory'))
        myChart.setOption({
          title: {
            text: this.echartTitle + this.$t('gpsStatistics'),
            left: 'left',
            textStyle: {
              color: this.echarts.textColor,
            },
          },
          tooltip: {
            trigger: 'item',
            transitionDuration: 0, //提示框浮层的移动动画过渡时间，单位是 s，设置为 0 的时候会紧跟着鼠标移动,加上这个可以防止抖动
          },
          color: this.echarts.activeColor,
          legend: {
            top: '5%',
            data: [this.$t('distance')],
            textStyle: {
              color: this.echarts.textColor,
            },
          },
          xAxis: {
            type: 'category',
            data: this.userEchart.GJxAxis,
            axisLabel: {
              //展示角度
              // rotate: 30,
              textStyle: {
                color: this.echarts.textColor,
              },
            },
            axisLine: {
              lineStyle: {
                color: this.echarts.Yline, //更改坐标轴颜色
              },
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: this.echarts.textColor,
              },
            },
            splitLine: {
              // 自定义网格线样式
              lineStyle: {
                type: 'solid',
                color: this.echarts.Yline,
              },
            },
            axisLine: {
              lineStyle: {
                color: this.echarts.Yline, //更改坐标轴颜色
              },
            },
          },
          grid: {
            top: 60,
            left: 27,
            right: 5,
            bottom: 20,
            containLabel: true,
          },
          series: [
            {
              data: this.traceData.traceLineData,
              type: 'bar',
              barWidth: 30, //柱图宽度
              name: this.$t('distance'),
              itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: 'top', //在上方显示
                    textStyle: {
                      //数值样式
                      color: '#2096FF',
                      fontSize: 16,
                    },
                  },
                },
              },
            },
          ],
        })
      })
    },
    // 当前机构/用户
    handleNodeClick(data, node) {
      this.$refs.dataStaticTree.setCurrentKey(node.id)
      this.currentItem = data
      this.getAllFullNames()
      this.getMapIncludeChild()
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.mechanismData = res.data
          this.currentItem = this.mechanismData[0]
          this.$nextTick(() => {
            this.$refs.dataStaticTree.setCurrentKey(this.currentItem.id)
          })
          this.getAllFullNames()
          this.getMapIncludeChild()
        }
      })
    },
    // 获取当前机构下 所有用户
    getAllFullNames() {
      allFullNames(this.currentItem).then(res => {
        if (res.state === 0) {
          this.userNames = res.data
          this.selectTimeSlot()
        }
      })
    },
    // 获取当前机构下 所有子机构
    getMapIncludeChild() {
      ouMapIncludeChildren(this.currentItem).then(res => {
        if (res.state === 0) {
          this.mapIncludeChild = res.data
        }
      })
    },
    // 轨迹统计查询接口
    getTraceData() {
      let param = {
        ouId: this.currentItem.id,
        logDateBegin: this.formInline.logDateBegin,
        logDateEnd: this.getTimeE,
        isContainChild: this.formInline.isContainChild,
      }
      getStatisTrace(param).then(res => {
        if (res.state === 0) {
          this.traceData = { traceXAxis: [], traceLineData: [] }
          // this.traceData.traceLineData
          if (res.value.helmetTraceMap !== {}) {
            var totleActivity = null
            var fixedActivity = 0
            var parentOuName = null
            if (this.activeName === 'mechanism') {
              // 当按机构查询时
              for (let childItem of this.mapIncludeChild) {
                // 循环子机构
                if (res.value.ouId === childItem.id) {
                  parentOuName = childItem.name
                }
                var numOuId = BigInt(childItem.id)
                if (res.value.helmetTraceMap[numOuId] !== undefined) {
                  // 判断返回的数据里 是否有这个子机构的数据
                  // 计算总的子机构数据
                  let keepOne = Number(res.value.helmetTraceMap[numOuId][-1])
                  totleActivity = totleActivity + keepOne
                  fixedActivity = totleActivity.toFixed(2)

                  if (res.value.ouId !== childItem.id) {
                    // 计算每个子机构的数据，并添加到数组里
                    var mini = Number(res.value.helmetTraceMap[numOuId][-1])
                    let traceMini = mini.toFixed(2)
                    this.traceData.traceXAxis.push(childItem.name)
                    this.traceData.traceLineData.push(traceMini)
                  }
                }
              }
              this.traceData.traceXAxis.unshift(parentOuName)
              this.traceData.traceLineData.unshift(fixedActivity)
              if (this.traceData.traceXAxis.length > 0) {
                let tracePage = Math.ceil(this.traceData.traceXAxis.length / 11)
                this.traceTimeLine.totalData = tracePage
                this.traceTimeLine.traceOnline = splitArray(this.traceData.traceLineData, 11)
                this.traceTimeLine.XuserData = splitArray(this.traceData.traceXAxis, 11)
                this.traceData.traceLineData = this.traceTimeLine.traceOnline[0]
                this.userEchart.GJxAxis = this.traceTimeLine.XuserData[0]
              } else {
                // 总页数
                this.traceTimeLine.totalData = 0
              }
              this.getTrajectory()
            } else {
              // 按用户显示轨迹数据
              let traceSortData = []
              for (let childActiceItem of this.mapIncludeChild) {
                var activeOuId =
                  childActiceItem.id.length > 16 ? BigInt(childActiceItem.id) : Number(childActiceItem.id)

                if (res.value.helmetTraceMap[activeOuId] !== undefined) {
                  for (let activeUser of this.userNames) {
                    var activeUserId = activeUser.id.length > 16 ? BigInt(activeUser.id) : Number(activeUser.id)
                    if (res.value.helmetTraceMap[activeOuId][activeUserId] !== undefined) {
                      var userTimeSecond = Number(res.value.helmetTraceMap[activeOuId][activeUserId].distance)
                      let traceSecond = userTimeSecond.toFixed(2)
                      // this.traceData.traceXAxis.push(activeUser.name)
                      traceSortData.push({
                        name: activeUser.name,
                        userNum: traceSecond,
                      })
                    }
                  }
                }
              }
              this.handleTrace(traceSortData)
            }
            this.traceTimeLine.totalUser = this.traceData.traceLineData.length ? this.traceData.traceLineData.length : 0
            // this.arrayChunk()
          }
        }
      })
    },
    // 获取数据
    _getStatistics(resetPage = false) {
      console.log('_getStatistics', resetPage)
      if (resetPage) {
        this.userTimeLineCurrentPage = 1
        this.userTimeLineCurrentPage = 1
        this.mediaTimeLineCurrentPage = 1
        this.duratTimeLineCurrentPage = 1
        this.traceTimeLineCurrentPage = 1
        this.staticProportCurrentPage = 1
        this.userTimeLine = {
          totalUser: 0,
          currentPage: 1,
          totalData: 0,
          pageSize: 11,
        }
        // 机构媒体分页数据
        this.mediaTimeLine = {
          totalUser: 0,
          currentPage: 1,
          totalData: 0,
          pageSize: 11,
        }
        // 机构视频总时长分页数据
        this.duratTimeLine = {
          totalUser: 0,
          currentPage: 1,
          totalData: 0,
          pageSize: 11,
        }
        // 轨迹统计分页数据
        this.traceTimeLine = {
          totalUser: 0,
          currentPage: 1,
          totalData: 0,
          pageSize: 11,
        }
        this.$forceUpdate()
      }
      this.getTraceData()
      if (this.formInline.logDateBegin === '' || this.getTimeE === '') {
        this.timeSelect = 'all'
      }
      let param = {
        ouId: this.currentItem.id,
        logDateBegin: this.formInline.logDateBegin,
        logDateEnd: this.getTimeE,
        isContainChild: this.formInline.isContainChild,
      }
      getStatistics(param).then(res => {
        if (res.state === 0) {
          this.statisticsData = res.value
          this.proport.UseProportion = []
          this.seriesData = []
          this.mapXAxisData = []
          if (res.value.helmetUsedMap[-1]) {
            if (this.activeName === 'mechanism') {
              let unUse = res.value.helmetUsedMap[-1].helmetCountAll - res.value.helmetUsedMap[-1].helmetCountUsed
              this.proport.UseProportion.push({ value: unUse, name: this.$t('unUse') })
              this.proport.UseProportion.push({
                value: res.value.helmetUsedMap[-1].helmetCountUsed,
                name: this.$t('use'),
              })
              this.pieTitle.parTitle = this.$t('mechanismRate')
              this.pieTitle.seriesName = this.$t('deviceNum')
            }
          }
          var parentOuName = null
          // 机构/用户活跃度
          if (res.value.userOnlineMap !== {}) {
            // 定义总的数
            var totleActivity = null
            if (this.activeName === 'mechanism') {
              // 当按机构查询时
              for (let childItem of this.mapIncludeChild) {
                if (res.value.ouId === childItem.id) {
                  // X轴数据添加总的机构名称
                  parentOuName = childItem.name
                }
                var numOuId = BigInt(childItem.id)
                if (res.value.userOnlineMap[numOuId] !== undefined) {
                  // 计算总的机构的数据
                  totleActivity = totleActivity + res.value.userOnlineMap[numOuId][-1] / 60
                  if (res.value.ouId !== childItem.id) {
                    // 计算子机构的数据并添加至数组
                    var mini = parseInt(res.value.userOnlineMap[numOuId][-1] / 60)
                    this.mapXAxisData.push(childItem.name)
                    this.seriesData.push(mini)
                  }
                }
              }
              this.mapXAxisData.unshift(parentOuName)
              this.seriesData.unshift(parseInt(totleActivity))
            } else {
              // 当按用户查询时
              var totalOportions = 0
              var proportionData = []
              for (let childActiceItem of this.mapIncludeChild) {
                var activeOuId =
                  childActiceItem.id.length > 16 ? BigInt(childActiceItem.id) : Number(childActiceItem.id)

                if (res.value.userOnlineMap[activeOuId] !== undefined) {
                  // 查询子机构是否存在数据里
                  for (let activeUser of this.userNames) {
                    var activeUserId = activeUser.id.length > 16 ? BigInt(activeUser.id) : Number(activeUser.id)
                    if (res.value.userOnlineMap[activeOuId][activeUserId] !== undefined) {
                      // 判断存在的子机构里的用户存在
                      var userTimeSecond = parseInt(
                        res.value.userOnlineMap[activeOuId][activeUserId].onlineTimeSecond / 60
                      )
                      // this.mapXAxisData.push(activeUser.name)
                      // this.seriesData.push(userTimeSecond)
                      // 计算用户活跃度的总数，以便计算用户比例
                      totalOportions = totalOportions + userTimeSecond
                      proportionData.push({
                        name: activeUser.name,
                        userNum: userTimeSecond,
                      })
                    }
                  }
                }
              }
              this.pieTitle.parTitle = this.$t('activeUserRate')
              this.pieTitle.seriesName = this.$t('activeUser')
              this.handleOportions(totalOportions, proportionData)
            }
            this.getHistogram()
          }
          if (res.value.mediaMap !== {}) {
            // 媒体统计与视频总长
            this.mediaAudioData = []
            this.mediaMovieData = []
            this.mediaPhotoData = []
            this.mediaXdata = []
            this.videoDuration = []
            var totleAudio = null
            var totleMovie = null
            var totlePhoto = null
            this.timeData = []
            var totleTime = 0
            var fixedTime = 0
            if (this.activeName === 'mechanism') {
              // 按机构看,统计数
              for (let mediaItem of this.mapIncludeChild) {
                if (res.value.ouId === mediaItem.id) {
                  parentOuName = mediaItem.name
                }
                var numOuId = BigInt(mediaItem.id)
                if (res.value.mediaMap[numOuId] !== undefined) {
                  var mediaValue = res.value.mediaMap[numOuId][-1]
                  // 音频总计
                  totleAudio = totleAudio + Number(mediaValue[0].ouTotalAudio)
                  // 视频总计
                  totleMovie = totleMovie + Number(mediaValue[0].ouTotalMovie)
                  // 照片总计
                  totlePhoto = totlePhoto + Number(mediaValue[0].ouTotalPhoto)
                  // 视频总时长
                  let ouTotal = mediaValue[0].ouTotalMovieDuration / 1000 / 60
                  ouTotal = Number(ouTotal)
                  totleTime = totleTime + ouTotal
                  fixedTime = totleTime.toFixed(2)

                  if (res.value.ouId !== mediaItem.id) {
                    this.mediaAudioData.push(mediaValue[0].ouTotalAudio)
                    this.mediaMovieData.push(mediaValue[0].ouTotalMovie)
                    this.mediaPhotoData.push(mediaValue[0].ouTotalPhoto)
                    var intNumber = (mediaValue[0].ouTotalMovieDuration / 1000 / 60).toFixed(2) // 计算视频时长，毫秒=》分钟
                    this.timeData.push(intNumber)
                    this.mediaXdata.push(mediaItem.name)
                    this.videoDuration.push(mediaItem.name)
                  }
                }
              }
              // 在数组之前添加总数
              this.mediaXdata.unshift(parentOuName)
              this.videoDuration.unshift(parentOuName)
              this.mediaAudioData.unshift(totleAudio)
              this.mediaMovieData.unshift(totleMovie)
              this.mediaPhotoData.unshift(totlePhoto)
              this.timeData.unshift(fixedTime)
            } else {
              // 按用户看，统计数据
              this.timeData = []
              let mediaData = [this.$t('video'), this.$t('photo'), this.$t('voice')]
              let videoTime = []
              for (let mediaUserItem of this.mapIncludeChild) {
                var OuId = BigInt(mediaUserItem.id)
                if (res.value.mediaMap[OuId] !== undefined) {
                  for (let user of this.userNames) {
                    var userId = BigInt(user.id) // 用户id数字化，以便下标，BigInt：数字超16位使用
                    if (res.value.mediaMap[OuId][userId] !== undefined) {
                      let userMedia = []
                      let userIntNumber = 0
                      this.mediaXdata.push(user.name)
                      for (let media of res.value.mediaMap[OuId][userId]) {
                        // 用户媒体的种类,用来区分没有种类去加 0
                        userMedia.push(media.typeStr)
                        // 根据类型去相应的数组添加数据
                        if (media.typeStr === this.$t('video')) {
                          // item 判断为视频，往视频的数组添加数据
                          this.mediaMovieData.push(media.count)
                          // 用户的视频总长计算
                          // this.videoDuration.push(user.name) NOSONAR
                        } else if (media.typeStr === this.$t('photo')) {
                          // item 判断为照片，往照片的数组添加数据
                          this.mediaPhotoData.push(media.count)
                        } else {
                          // item 判断为音频，往音频的数组添加数据
                          this.mediaAudioData.push(media.count)
                        }
                      }
                      for (let movie of res.value.mediaMap[OuId][userId]) {
                        if (movie.typeStr === this.$t('video')) {
                          userIntNumber += Number(movie.duration / 1000 / 60)
                        }
                      }
                      userIntNumber = userIntNumber.toFixed(2)
                      videoTime.push({
                        name: user.name,
                        userNum: userIntNumber,
                      })
                      // 根据用户已有的媒体类型,去判断是否有数据,已方便数据叠加无错误 如果某个用户没有某个媒体类型，需添加 0
                      for (let userItem of mediaData) {
                        if (userItem === this.$t('video') && userMedia.indexOf(userItem) === -1) {
                          this.mediaMovieData.push(0)
                        } else if (userItem === this.$t('photo') && userMedia.indexOf(userItem) === -1) {
                          this.mediaPhotoData.push(0)
                        } else if (userItem === this.$t('voice') && userMedia.indexOf(userItem) === -1) {
                          this.mediaAudioData.push(0)
                        }
                      }
                    }
                  }
                }
              }
              this.handleVideo(videoTime)
            }
          }
          // 做数据截取
          setTimeout(() => {
            this.arrayChunk()
          }, 500)
          this.userTimeLine.totalUser = this.mapXAxisData.length ? this.mapXAxisData.length : 0
          this.mediaTimeLine.totalUser = this.mediaXdata.length ? this.mediaXdata.length : 0
          this.duratTimeLine.totalUser = this.videoDuration.length ? this.videoDuration.length : 0
        }
      })
    },
    // 导出统计数据
    _exportStatistics() {
      let params = {
        ouId: this.currentItem.id,
        logDateBegin: this.formInline.logDateBegin,
        logDateEnd: this.getTimeE,
        isContainChild: this.formInline.isContainChild,
      }
      exportStatistics(params).then(res => {
        downloadBlobExcel(res, this.$t('SystemStatistics') + '.xls')
      })
    },
    // 切换用户查看时，轨迹统计排序处理
    handleTrace(data) {
      data.sort(sortData)
      for (let item of data) {
        this.traceData.traceXAxis.push(item.name)
        this.traceData.traceLineData.push(item.userNum)
      }
      if (this.traceData.traceXAxis.length > 0) {
        let tracePage = Math.ceil(this.traceData.traceXAxis.length / 11)
        this.traceTimeLine.totalData = tracePage
        this.traceTimeLine.traceOnline = splitArray(this.traceData.traceLineData, 11)
        this.traceTimeLine.XuserData = splitArray(this.traceData.traceXAxis, 11)
        this.traceData.traceLineData = this.traceTimeLine.traceOnline[0]
        this.userEchart.GJxAxis = this.traceTimeLine.XuserData[0]
      } else {
        // 总页数
        this.traceTimeLine.totalData = 0
      }
      this.getTrajectory()
    },
    // 切换用户查看时，视频总时长排序处理
    handleVideo(data) {
      data.sort(sortData)
      for (let item of data) {
        this.videoDuration.push(item.name)
        this.timeData.push(item.userNum)
      }
    },
    // 切换用户查看时，用户比例数处理
    handleOportions(num, data) {
      this.proport = { UseProportion: [], Xproport: [] }
      this.seriesData = []
      this.mapXAxisData = []
      data.sort(sortData)
      for (let item of data) {
        let userProportion = ((item.userNum / num) * 100).toFixed(3)
        this.proport.UseProportion.push(userProportion)
        this.proport.Xproport.push(item.name)

        this.mapXAxisData.push(item.name)
        this.seriesData.push(item.userNum)
      }
      this.staticProport.totalUser = data.length ? data.length : 0
    },
    // 做数据截取
    arrayChunk() {
      // 页数向上取整
      if (this.proport.Xproport.length > 0 && this.proport.UseProportion) {
        let proportPage = Math.ceil(this.proport.UseProportion.length / 11)
        // 总页数
        this.staticProport.totalData = proportPage
        this.staticProport.proportOnline = splitArray(this.proport.UseProportion, 11)
        this.staticProport.XuserData = splitArray(this.proport.Xproport, 11)
        // 第一页数据
        this.proport.UseProportion = this.staticProport.proportOnline[0]
        this.proport.Xproport = this.staticProport.XuserData[0]
      } else {
        // 总页数
        this.staticProport.totalData = 0
      }
      //机构活跃度
      if (this.seriesData.length > 0) {
        // 页数向上取整
        let userPage = Math.ceil(this.seriesData.length / 11)
        // 总页数
        this.userTimeLine.totalData = userPage
        this.userTimeLine.userOnline = splitArray(this.seriesData, 11)
        this.userTimeLine.XuserData = splitArray(this.mapXAxisData, 11)
        // 第一页数据
        this.seriesData = this.userTimeLine.userOnline[0]
        this.userEchart.userxAxis = this.userTimeLine.XuserData[0]
      } else {
        // 总页数
        this.userTimeLine.totalData = 0
      }

      // 机构媒体
      if (this.mediaXdata.length > 0) {
        let mediaPage = Math.ceil(this.mediaXdata.length / 11)
        this.mediaTimeLine.totalData = mediaPage
        this.mediaTimeLine.mediaAudio = splitArray(this.mediaAudioData, 11)
        this.mediaTimeLine.mediaMovie = splitArray(this.mediaMovieData, 11)
        this.mediaTimeLine.mediaPhoto = splitArray(this.mediaPhotoData, 11)
        this.mediaTimeLine.XuserData = splitArray(this.mediaXdata, 11)

        this.mediaAudioData = this.mediaTimeLine.mediaAudio[0]
        this.mediaMovieData = this.mediaTimeLine.mediaMovie[0]
        this.mediaPhotoData = this.mediaTimeLine.mediaPhoto[0]
        console.log(this.mediaTimeLine.XuserData[0], '99')
        this.userEchart.mediaxAxis = this.mediaTimeLine.XuserData[0]
      } else {
        // 总页数
        this.mediaTimeLine.totalData = 0
      }

      // 机构视频总时长
      if (this.videoDuration.length > 0) {
        let duratPage = Math.ceil(this.videoDuration.length / 11)
        this.duratTimeLine.totalData = duratPage
        this.duratTimeLine.duratOnline = splitArray(this.timeData, 11)
        this.duratTimeLine.XuserData = splitArray(this.videoDuration, 11)
        this.timeData = this.duratTimeLine.duratOnline[0]
        this.userEchart.duratxAxis = this.duratTimeLine.XuserData[0]
      } else {
        // 总页数
        this.duratTimeLine.totalData = 0
      }

      if (this.traceData.traceXAxis.length > 0) {
        let tracePage = Math.ceil(this.traceData.traceXAxis.length / 11)
        this.traceTimeLine.totalData = tracePage
        this.traceTimeLine.traceOnline = splitArray(this.traceData.traceLineData, 11)
        this.traceTimeLine.XuserData = splitArray(this.traceData.traceXAxis, 11)
        this.traceData.traceLineData = this.traceTimeLine.traceOnline[0]

        this.userEchart.GJxAxis = this.traceTimeLine.XuserData[0]
      } else {
        // 总页数
        this.traceTimeLine.totalData = 0
      }

      // 更新 echarts
      this.getmediaStatistics()
      this.getTotalDuration()
      this.getUseProportion()
      this.getTrajectory()
      this.getHistogram()
    },
    // 机构活跃度统计切换分页
    handleCurrentChange(val) {
      this.userTimeLineCurrentPage = val
      this.userTimeLine.currentPage = val
      this.seriesData = this.userTimeLine.userOnline[val - 1]
      this.userEchart.userxAxis = this.userTimeLine.XuserData[val - 1]
      this.getHistogram()
    },
    // 机构媒体切换分页
    handleMediaChange(val) {
      this.mediaTimeLineCurrentPage = val
      this.mediaTimeLine.currentPage = val
      this.mediaAudioData = this.mediaTimeLine.mediaAudio[val - 1]
      this.mediaMovieData = this.mediaTimeLine.mediaMovie[val - 1]
      this.mediaPhotoData = this.mediaTimeLine.mediaPhoto[val - 1]
      this.userEchart.mediaxAxis = this.mediaTimeLine.XuserData[val - 1]

      this.getmediaStatistics()
    },
    // 机构视频总时长切换分页
    handleDuratChange(val) {
      this.duratTimeLineCurrentPage = val
      this.duratTimeLine.currentPage = val
      this.seriesData = this.duratTimeLine.duratOnline[val - 1]
      this.userEchart.duratxAxis = this.duratTimeLine.XuserData[val - 1]
      this.getTotalDuration()
    },
    // 轨迹切换分页
    handleTraceChange(val) {
      this.traceTimeLineCurrentPage = val
      this.traceTimeLine.currentPage = val
      this.traceData.traceLineData = this.traceTimeLine.traceOnline[val - 1]
      this.userEchart.GJxAxis = this.traceTimeLine.XuserData[val - 1]
      this.getTrajectory()
    },
    handleproportion(val) {
      this.staticProportCurrentPage = val
      this.staticProport.currentPage = val
      this.proport.UseProportion = this.staticProport.proportOnline[val - 1]
      this.proport.Xproport = this.staticProport.XuserData[val - 1]
      this.getUseProportion()
    },
  },
  created() {
    this.getOusTree()
    this.getHistogram()
    this.getTrajectory()
    this.getChartColor()
  },
  watch: {
    getTheme(val) {
      this.getChartColor(val)
    },
    // 机构树搜索名字监听
    filterText(val) {
      this.$refs.dataStaticTree.filter(val)
    },
  },
  computed: {
    // 主题切换标识监听
    getTheme() {
      return this.$store.state.theme
    },
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
.base_main
  height 100%
  .main
    height calc(100% - 130px)
  .common-aside-main
    margin-left 10px
.el-tree
  height calc(100% - 60px)
  overflow: auto
.custom-tree-node
  flex 1
  display flex
  align-items center
  justify-content space-between
  padding-right 20px
  width 100%
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
  .node-txt
    font-size 16px;/*no*/
.statis-chart
  display flex
  justify-content space-between
  height 48%
  margin-bottom 28px
  .user-activity
    width 48%
    height 100%
    position relative
    .pagination
      position absolute
      top 6%
      right 0
      display flex
      color #222
      span
        height: 30px;/*no*/
        line-height: 30px;/*no*/
.statis-echart
  padding-left 15px
  padding-top 15px
.serachBox
  margin 10px 0
  text-align center
  border-bottom none
  .el-input
    width 230px !important
.serachLine
  margin 10px 8px 10px 8px
  display flex
  align-items center
  justify-content center
  >>>.el-input__inner
    height 36px;/*no*/
    line-height 36px;/*no*/
   /deep/.el-input
    width 180px !important
  .serachBtn
    margin-left: 5px;
    padding: 10px 20px; /* no */
.theme-dark
  .statis-chart
    .user-activity
      .pagination
        color #fff
</style>
